export const ValidateBundle = ({ bundle }) => {
  if (
    bundle.compareAtPrice &&
    Number(bundle.compareAtPrice) < Number(bundle.price)
  ) {
    return {
      field: "Discount",
      error: "Compare at price cannot be less than the price.",
    };
  }
  if (!bundle.name) {
    return {
      field: "Name",
      error: "Please provide a name for your bundle",
    };
  }

  if (!bundle.description) {
    return {
      field: "Description",
      error: "Description cannot be empty",
    };
  }

  if (!bundle.category) {
    return {
      field: "Category",
      error: "Category cannot be empty",
    };
  }

  if (!bundle.components || !bundle.components.length) {
    return {
      field: "Products",
      error: "You need to select at least one product",
    };
  }

  // if (!bundle.sku) {
  //   return {
  //     field: "Sku",
  //     error: "You need to provide a SKU.",
  //   };
  // }
  if (bundle.components) {
    for (const product of bundle.components) {
      if (!product.dimensions.weight || Number(product.dimensions.weight) < 0) {
        return {
          field: "Products",
          error:
            "You need to provide weight for all the selected products. It should be greater than 0.",
        };
      }
      if (!product.dimensions.length || Number(product.dimensions.length) < 0) {
        return {
          field: "Products",
          error:
            "You need to provide Length for all the selected products. It should be greater than 0.",
        };
      }
      if (!product.dimensions.width || Number(product.dimensions.width) < 0) {
        return {
          field: "Products",
          error:
            "You need to provide Width for all the selected products. It should be greater than 0.",
        };
      }
      if (!product.dimensions.height || Number(product.dimensions.width) < 0) {
        return {
          field: "Products",
          error:
            "You need to provide Height for all the selected products It should be greater than 0.",
        };
      }
    }
  }
  // if (bundle.trackInventory && (!bundle.inventory || bundle.inventory < 0)) {
  //   return {
  //     field: "Inventory",
  //     error:
  //       "Inventory cannot be 0 or less than 0  when you are tracking inventory",
  //   };
  // }
  // if (!bundle.trackInventory && bundle.inventory) {
  //   return {
  //     field: "Inventory",
  //     error: "Inventory must be 0 when you are not tracking inventory",
  //   };
  // }

  if (!bundle.price) {
    return {
      field: "Price",
      error: "Price cannot be empty",
    };
  }
  if (Number(bundle.price) < 99) {
    return {
      field: "Price",
      error: "Price cannot be less than 99",
    };
  }
  // if (!bundle.costOfGoods) {
  //   return {
  //     field: "Cost of goods",
  //     error: "Cost of goods cannot be empty",
  //   };
  // }

  if (bundle.onSale && !bundle.discount) {
    return {
      field: "Discount",
      error: "If the bundle is on sale, you need to provide a discount value.",
    };
  }

  return null; // No errors
};
